import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import {fetchGoogleStores} from '../../scripts/dataTable';
import {paths} from '../../config/app-config';
import UploadCard from '../Widgets/UploadCard';
import ExportButton from '../Widgets/ExportButton';
import GSFButton from '../Widgets/GoogleSyncButton'
import {importExportContext} from '../../context/importExportContext';
import Summary from '../Widgets/Summary';

const useStyles = makeStyles({
  listItem: {
    boxShadow: '0 2px 6px 0 rgba(0,0,0,0.1)',
    transition: '0.2s',
    color: '#3c3c3c',
    background: 'white',
    margin: '0 0 10px;',
    '&:hover': {
      background: 'lightblue',
      color: 'black',
      cursor: 'pointer'
    },
  },
  listItemSelected: {
    background: 'lightblue',
    color: 'black',
  },

});

const UploadSummary = (param) => {
  switch (param.flag) {
    case -1:
      return null;
    case 1:
      return <Summary title="Upload Summary" body={param.body} type="primary"/>
    case 0:
      return <Summary title="Upload Error" body={param.body} type="secondary"/>
    default:
      return null;
  }
}

const LocaleContainer = (props) => {
  const classes = useStyles();
  const [stores, setStores] = useState([]);
  const [currentStoreId, setCurrentStoreId] = useState(null);
  const [currentStoreLanguage, setCurrentStoreLanguage] = useState(null);
  const [currentStoreCountry, setCurrentStoreCountry] = useState(null);
  const [uploadAreaVisible, setUploadAreaVisibility] = useState(false);
  const [isUploadSuccess, setUploadStatus] = useState(-1);
  const [uploadSummary, setUploadSummary] = useState([]);

  async function fetchData() {
    try {
      const fetchedValues = await fetchGoogleStores(
          paths.listPath('googleshopping'));
      setStores(fetchedValues.stores);
    } catch (e) {
      // If there is an error, setStores to []
      setStores([]);
    }
  }

  function setStoreConfiguration(e) {
    let data = e.currentTarget.dataset;
    data = JSON.parse(JSON.stringify(data));
    const storeId = data.storeid;
    const storeLanguage = data.storelanguage;
    const storeCountry = data.storecountry;

    setCurrentStoreId(storeId);
    setCurrentStoreLanguage(storeLanguage);
    setCurrentStoreCountry(storeCountry);

    if (!uploadAreaVisible) {
      setUploadAreaVisibility(!uploadAreaVisible);
    }
  }

  useEffect(() => {
    fetchData()
  }, []);

  return (
      <Grid container spacing={2} scrollable={"virtual"} data-testid="grid-container">
        <Grid item xs={3} data-testid="grid-item">
          <List dense={true} data-testid="list">
            {stores.length > 0 ?
                stores.map((store) => {
                  return (
                      <ListItem data-testid="list-item"
                          data-storeid={store.storeId}
                          data-storelanguage={store.language}
                          data-storecountry={store.country}
                          onClick={setStoreConfiguration}
                          className={`${classes.listItem} ${currentStoreId
                          == store.storeId ? classes.listItemSelected
                              : ''}`} // eslint-disable-line
                          key={store.storeId}
                      >
                        <ListItemText
                            primary={store.name}
                            secondary={store.storeId}
                        />
                      </ListItem>
                  )
                })
                :
                <ListItem data-testid="list-item">
                  <ListItemText
                      primary='Insert Store information before adding products'
                  />
                </ListItem>
            }
          </List>
        </Grid>

        {uploadAreaVisible ?
            <Grid item xs={8}>
              <importExportContext.Provider value={{
                isUploadSuccess,
                uploadSummary,
                setUploadStatus: (status) => setUploadStatus(status),
                setUploadSummary: (data) => setUploadSummary(data),
              }}>
                <div className="pda-locale-upload-container">
                  <UploadCard
                      from={props.from}
                      data={currentStoreLanguage.toLowerCase() + "_"
                      + currentStoreCountry.toUpperCase()}
                  />
                  <ExportButton
                      className="pda-locale-upload-button-medium"
                      from={props.from}
                      storeLanguage={currentStoreLanguage}
                      storeCountry={currentStoreCountry}
                      buttonText={props.buttonText}
                  />

                  {/*<GSFButton className="pda-locale-upload-button-medium"
                             storeLanguage={currentStoreLanguage}
                             storeCountry={currentStoreCountry}
                             from={props.from} buttonText={"Sync GSF"}>
                  </GSFButton>*/}

                  <UploadSummary
                      flag={isUploadSuccess}
                      body={uploadSummary}
                  />
                </div>
              </importExportContext.Provider>
            </Grid>
            :
            <div></div>
        }
      </Grid>
  )
}

export default LocaleContainer;
